module.exports = __webpack_public_path__ + "static/media/ben.a7c7e4e0.jpg";